import * as yup from "yup";

export const ClientBankSetupValidationSchema = yup.object().shape({
  accountNo: yup.string().required("Bank Account No is required"),
  branchTransitNumber: yup
    .string()
    .required("Bank Branch Transit Number is required"),
  bankFinancialNo: yup.string().required("Bank Bank Financial No is required"),
});
